/* ── Extract lat/lng from address object ── */
export function getLatLng(address) {
  if (!address) return null;

  const coordinateCandidates = [];

  // GeoJSON: { coordinates: [lng, lat] } at root
  if (Array.isArray(address?.coordinates) && address.coordinates.length === 2) {
    coordinateCandidates.push({ lng: Number(address.coordinates[0]), lat: Number(address.coordinates[1]) });
  }

  // GeoJSON: { location: { coordinates: [lng, lat] } }
  if (Array.isArray(address?.location?.coordinates) && address.location.coordinates.length === 2) {
    coordinateCandidates.push({ lng: Number(address.location.coordinates[0]), lat: Number(address.location.coordinates[1]) });
  }

  // { location: { lat, lng } }
  if (address?.location?.lat != null && address?.location?.lng != null) {
    coordinateCandidates.push({ lat: Number(address.location.lat), lng: Number(address.location.lng) });
  }

  // { latitude, longitude }
  if (address?.latitude != null && address?.longitude != null) {
    coordinateCandidates.push({ lat: Number(address.latitude), lng: Number(address.longitude) });
  }

  // { lat, lng }
  if (address?.lat != null && address?.lng != null) {
    coordinateCandidates.push({ lat: Number(address.lat), lng: Number(address.lng) });
  }

  // { geo: { coordinates: [lng, lat] } }
  if (Array.isArray(address?.geo?.coordinates) && address.geo.coordinates.length === 2) {
    const [lng, lat] = address.geo.coordinates;
    coordinateCandidates.push({ lat: Number(lat), lng: Number(lng) });
  }

  for (const candidate of coordinateCandidates) {
    if (Number.isFinite(candidate.lat) && Number.isFinite(candidate.lng) && candidate.lat !== 0 && candidate.lng !== 0) {
      return { lat: candidate.lat, lng: candidate.lng };
    }
  }

  return null;
}

/* ── Format address object to readable string ── */
export function getAddressText(address) {
  if (!address) return "";
  if (typeof address === "string") return address.trim();
  if (address.fullAddress) return address.fullAddress;
  if (address.formattedAddress) return address.formattedAddress;

  const parts = [];
  const addLine1 = address.addressLine1 || address.street || address.line1 || address.address;
  const addLine2 = address.addressLine2 || address.street2 || address.line2;
  const city = address.city || address.town || address.locality;
  const state = address.state || address.region;
  const pincode = address.pincode || address.postalCode || address.zipCode;
  const country = address.country;
  const name = address.fullName || address.name || address.recipientName || address.contactName;

  if (name) parts.push(name);
  if (addLine1) parts.push(addLine1);
  if (addLine2) parts.push(addLine2);
  if (city) parts.push(city);
  if (state) parts.push(state);
  if (pincode) parts.push(pincode);
  if (country) parts.push(country);

  return parts.filter(Boolean).join(", ").trim();
}